import React, { FC, ReactNode, useCallback, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Button } from 'src/common';
import classNames from 'classnames';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TenderBlockSize } from 'src/models/procurements/Tender/types';

export interface IProps {
  value: ReactNode;
  title?: string;
  index: number;
  isExpanded?: boolean;
  expandable?: boolean;
  className?: string;
  size?: TenderBlockSize;
  actions?: ReactNode;
  setIsHovered?: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ListBox: FC<IProps> = ({
  title,
  value,
  index,
  isExpanded: isAllExpanded,
  expandable = false,
  className,
  size = TenderBlockSize.Full,
  actions,
  setIsHovered
}) => {
  const [isExpanded, toggleIsExpanded] = useState(isAllExpanded || false);

  const onToggle = useCallback(() => {
    toggleIsExpanded(prev => !prev);
  }, []);

  useEffect(() => {
    toggleIsExpanded(!!isAllExpanded);
  }, [isAllExpanded, toggleIsExpanded]);

  const updateStateOnTitleHover = useCallback(
    value => {
      setIsHovered?.(value);
    },
    [setIsHovered]
  );

  const updateStateOnContentHover = useCallback(
    value => {
      if (!title) {
        setIsHovered?.(value);
      }
    },
    [title, setIsHovered]
  );

  return (
    <div
      className={classNames(
        styles.box,
        styles[size],
        styles.listBox,
        { [styles.isExpanded]: isExpanded, [styles.expandable]: expandable },
        !!className && className
      )}
    >
      <span className={styles.index}>{index}</span>
      <div className={styles.content}>
        {title && (
          <div
            className={styles.title}
            onMouseEnter={() => updateStateOnTitleHover(true)}
            onMouseLeave={() => updateStateOnTitleHover(false)}
          >
            <div>
              <label className={styles.label} htmlFor={title}>
                {title}
              </label>
              {!!actions && <>{actions}</>}
            </div>
            {expandable ? (
              <Button
                id={title}
                className={styles.button}
                icon={
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className={classNames(styles.icon, { [styles.isExpanded]: isExpanded })}
                  />
                }
                type={'text'}
                onClick={onToggle}
              ></Button>
            ) : null}
          </div>
        )}
        <div
          className={styles.value}
          onMouseEnter={() => updateStateOnContentHover(true)}
          onMouseLeave={() => updateStateOnContentHover(false)}
        >
          {value}
        </div>
      </div>
    </div>
  );
};

export default ListBox;
